// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3lOor","rootSuccess":"CompleteLink_rootSuccess__2jvc0","rootFailure":"CompleteLink_rootFailure__Ostfz","isDisabled":"CompleteLink_isDisabled__2kFfH"};